import { Component, HostListener, NgZone } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  standalone: true,
  selector: 'app-interview-completed',
  templateUrl: './interview-completed.html',
  styleUrl: './interview-completed.css'

})
export class InterviewCompleted {
  constructor(private toastr: ToastrService, private ngZone: NgZone) { }

  navigationBlocked: boolean = true;

  ngOnInit() {
    history.pushState(null, '', location.href);
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event: any) {
    this.ngZone.run(() => {
      this.toastr.warning('Please close the window to exit.', 'Navigation Restricted');
      history.pushState(null, '', location.href);
    });
  }

  canExitPerformance(): boolean {
    return !this.navigationBlocked;
  }

}
